import classNames from "classnames";
import CiroButton, { CiroButtonStyleEnum } from "../../../shared/CiroButton";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface IAutopilotSessionWebhookExportModalHeaderProps {
  title: string;
  onClose: () => void;
}

const AutopilotSessionWebhookExportModalHeader = ({
  title,
  onClose,
}: IAutopilotSessionWebhookExportModalHeaderProps) => {
  return (
    <div className={classNames("flex", "justify-between", "items-center")}>
      <h2 className={classNames("text-lg", "font-semibold", "text-gray-900")}>
        {title}
      </h2>
      <CiroButton
        onClick={onClose}
        style={CiroButtonStyleEnum.UNSTYLED}
        analyticsField={"Close export to webhook modal"}
      >
        <XMarkIcon className={classNames("h-6", "w-6")} />
      </CiroButton>
    </div>
  );
};

export default AutopilotSessionWebhookExportModalHeader;
